import React, { useEffect, useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import $ from "jquery";
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import { useContextProducto } from "../../../contexto/producto/ProductoContext";
import EliminarProducto from "./EliminarProductos";
import ModalProducto from "./ModalProducto";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";

const TablaProductos = ({ datos }) => {
  const { token } = useContextUsuario();
  const { setListaProductos, ActualizarLista } = useContextEmpleado();
  const tableRef = useRef();
  useEffect(() => {
    $(tableRef.current).DataTable({
      data: datos,
      columns: [
        {
          targets: 0,
          title: "Opciones",
          data: null,
          className: "dt-center",
          searchable: false,
          createdCell: (td, cellData, rowData, row, col) => {
            const root = createRoot(td);
            root.render(
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "1em",
                  }}
                >
                  <ModalProducto
                    datos={rowData}
                    token={token}
                    setListaProductos={setListaProductos}
                    ActualizarLista={ActualizarLista}
                  />
                  <EliminarProducto
                    datos={rowData}
                    token={token}
                    setListaProductos={setListaProductos}
                    ActualizarLista={ActualizarLista}
                  />
                </div>
              </>
            );
          },
          orderable: false,
        },
        { targets: 1, title: "Id", data: "id" },
        { targets: 2, title: "Nombre", data: "nombre" },
        { title: "Código", data: "codigo" },
        { targets: 3, title: "Existencia", data: "existencia" },
        { targets: 4, title: "Precio", data: "precio" },
        { targets: 5, title: "Impuesto", data: "impuesto" },
        {
          targets: 6,
          title: "Estado",
          data: "estado",
          render: (data, type, row, meta) => {
            return `<span class="badge ${
              data == "Activo" ? "badge-success" : "badge-danger"
            }">${data}</span>`;
          },
        },
      ],
      paging: true,
      lengthChange: true,
      pageLength:10,
      searching: true,
      ordering: true,
      info: true,
      autoWidth: true,
      responsive: true,
      language: {
        decimal: "",
        emptyTable: "No hay información",
        info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
        infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
        infoFiltered: "(Filtrado de _MAX_ total entradas)",
        infoPostFix: "",
        thousands: ",",
        lengthMenu: "Mostrar _MENU_ Entradas",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        search: "Buscar:",
        zeroRecords: "Sin resultados encontrados",
        paginate: {
          first: "|<<",
          last: ">>|",
          next: ">>",
          previous: "<<",
        },
      },
      destroy: true,
    });
    //}
  }, [datos]);

  return (
    <table
      ref={tableRef}
      id="productos"
      className="table table-bordered table-hover"
    ></table>
  );
};

export default TablaProductos;